import { useHistory } from "react-router-dom"
import { Link } from '@material-ui/core';
import { IState } from "views/Tickets/TicketsContext";
import { useContext } from "react";
import { applicationContext } from "helpers/services";

interface IProps {
    csAssignee?: string
    assignee?: string
    value: number
    supplier: string
}

let ClickableAssignee = (props: IProps) => {
    let history = useHistory<IState>();

    let { ticketStatuses } = useContext(applicationContext);

    const unassigned = "unassigned"

    return (
        <>
            {props.value === 0 && '-'}
            {props.value > 0 &&
                <Link
                    component="button"
                    onClick={() => history.push(
                        history.location.pathname,
                        {
                            search: {
                                customerStatus: [],
                                userGroup: "",
                                supplier: props.supplier,
                                pageNr: 0,
                                pageSize: 20,
                                fullText: "",
                                lastUpdatedOnFrom: null,
                                assignee: props.assignee === unassigned ? "null" : (props.assignee || ""),
                                csAssignee: props.csAssignee === unassigned ? "null" : (props.csAssignee || ''),
                                reporter: '',
                                reporterName: '',
                                status: ticketStatuses.filter(x => !x.isResolved).map(x => x.id),
                                type: "",
                                customerOrder: '',
                                productSKU: '',
                                customerM3Id: '',
                                customerName: '',
                                serviceOrder: '',
                                serialNumber: ''
                            },
                            queue: "",
                            supplier: ""
                        }
                    )}
                >
                    {props.value === 0 ? "-" : props.value}
                </Link>
            }
        </>
    )
}
export default ClickableAssignee